import React from 'react';
import styled from 'styled-components';

const PrivacyPolicyPage = () => {
    return (
        <PrivacyContainer>
            {/* Header Section */}
            <HeaderSection>
                <BackgroundLabel>PRIVACY</BackgroundLabel>
                <MainTitle>
                    Politique de Confidentialité
                </MainTitle>
                <SubTitle>
                    Dernière mise à jour : {new Date().toLocaleDateString()}
                </SubTitle>
            </HeaderSection>

            {/* Content Section */}
            <ContentSection>
                <PolicyBlock>
                    <BlockTitle>1. Collecte des données</BlockTitle>
                    <BlockText>
                        Nous collectons uniquement les données personnelles nécessaires pour améliorer votre expérience avec VOLTAUTO. Ces informations peuvent inclure :
                        <List>
                            <ListItem>Informations de contact (nom, email, téléphone)</ListItem>
                            <ListItem>Données de navigation sur notre site</ListItem>
                            <ListItem>Préférences de configuration de véhicule</ListItem>
                            <ListItem>Historique des interactions avec notre service client</ListItem>
                        </List>
                    </BlockText>
                </PolicyBlock>

                <PolicyBlock>
                    <BlockTitle>2. Utilisation des données</BlockTitle>
                    <BlockText>
                        Vos données sont utilisées pour :
                        <List>
                            <ListItem>Personnaliser votre expérience utilisateur</ListItem>
                            <ListItem>Améliorer nos produits et services</ListItem>
                            <ListItem>Communiquer sur nos innovations</ListItem>
                            <ListItem>Assurer la sécurité de nos services</ListItem>
                        </List>
                    </BlockText>
                </PolicyBlock>

                <PolicyBlock>
                    <BlockTitle>3. Protection des données</BlockTitle>
                    <BlockText>
                        VOLTAUTO met en œuvre des mesures de sécurité avancées pour protéger vos données personnelles contre tout accès non autorisé, modification, divulgation ou destruction. Nos protocoles de sécurité sont régulièrement mis à jour pour garantir une protection optimale.
                    </BlockText>
                </PolicyBlock>

                <PolicyBlock>
                    <BlockTitle>4. Vos droits</BlockTitle>
                    <BlockText>
                        Conformément au RGPD, vous disposez des droits suivants :
                        <List>
                            <ListItem>Droit d'accès à vos données personnelles</ListItem>
                            <ListItem>Droit de rectification des données inexactes</ListItem>
                            <ListItem>Droit à l'effacement de vos données</ListItem>
                            <ListItem>Droit à la limitation du traitement</ListItem>
                            <ListItem>Droit à la portabilité de vos données</ListItem>
                        </List>
                    </BlockText>
                </PolicyBlock>
            </ContentSection>

            {/* Contact Section */}
            <ContactSection>
                <ContactTitle>Une question sur la confidentialité ?</ContactTitle>
                <ContactText>
                    Notre équipe de protection des données est là pour vous répondre.
                </ContactText>
                <ContactButton href="/contact">
                    Contactez-nous
                </ContactButton>
            </ContactSection>
        </PrivacyContainer>
    );
};

export default PrivacyPolicyPage;


const PrivacyContainer = styled.div`
    min-height: 100vh;
    background: white;
    padding: 2rem 0;
`;

const HeaderSection = styled.header`
    padding: 4rem;
    position: relative;
    margin-bottom: 4rem;

    @media (max-width: 768px) {
        padding: 2rem;
    }
`;

const BackgroundLabel = styled.div`
    font-size: 1rem;
    color: rgba(0, 0, 0, 0.3);
    margin-bottom: 1rem;
    text-transform: uppercase;
    letter-spacing: 0.2em;
`;

const MainTitle = styled.h1`
    font-size: clamp(2.5rem, 5vw, 4rem);
    font-weight: 700;
    color: rgba(0, 0, 0, 0.8);
    line-height: 1.2;
    margin: 0;
`;

const SubTitle = styled.p`
    font-size: 1rem;
    color: rgba(0, 0, 0, 0.5);
    margin-top: 1rem;
`;

const ContentSection = styled.div`
    max-width: 900px;
    margin: 0 auto;
    padding: 0 2rem;
    display: flex;
    flex-direction: column;
    gap: 4rem;

    @media (max-width: 768px) {
        padding: 0 1rem;
        gap: 2rem;
    }
`;

const PolicyBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

const BlockTitle = styled.h2`
    font-size: 1.5rem;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
`;

const BlockText = styled.div`
    font-size: 1.1rem;
    line-height: 1.6;
    color: rgba(0, 0, 0, 0.6);
`;

const List = styled.ul`
    margin-top: 1rem;
    padding-left: 1.5rem;
`;

const ListItem = styled.li`
    margin-bottom: 0.5rem;
    
    &:last-child {
        margin-bottom: 0;
    }
`;

const ContactSection = styled.div`
    margin-top: 6rem;
    text-align: center;
    padding: 4rem 2rem;
    background: rgba(0, 0, 0, 0.02);

    @media (max-width: 768px) {
        margin-top: 4rem;
        padding: 2rem 1rem;
    }
`;

const ContactTitle = styled.h3`
    font-size: 2rem;
    font-weight: 600;
    margin-bottom: 1rem;
    color: rgba(0, 0, 0, 0.8);
`;

const ContactText = styled.p`
    font-size: 1.1rem;
    color: rgba(0, 0, 0, 0.6);
    margin-bottom: 2rem;
`;

const ContactButton = styled.a`
    display: inline-block;
    padding: 1rem 2rem;
    background: black;
    color: white;
    text-decoration: none;
    border-radius: 4px;
    font-weight: 500;
    transition: all 0.3s ease;

    &:hover {
        background: #333;
        transform: translateY(-2px);
    }
`;

